import { makeStyles } from '@material-ui/core/styles';

const CRED_ITEM_HEIGHT = 46;
const CRED_ITEMS_VISIBLE = 8;
const CRED_BANNER_HEIGHT = '48';
export const usePollingStyles = makeStyles((theme) => ({
    credentialButton: {
        alignSelf: 'flex-start',
        marginTop: theme.spacing(3),
    },
    credentialTabs: {
        marginTop: theme.spacing(3),
    },
    credentialList: {
        padding: '0px',
        border: `1px solid ${theme.palette.divider}`,
        maxHeight: `${CRED_BANNER_HEIGHT * CRED_ITEMS_VISIBLE}px`,
        overflowY: 'auto',
        overflowX: 'none',
    },
    credentialListDragging: {
        '& .MuiListItem-button:hover': {
            backgroundColor: 'transparent',
        },
    },
    credentialListBanner: {
        height: CRED_BANNER_HEIGHT,
        lineHeight: `${CRED_BANNER_HEIGHT}px`,
    },

    credentialListItem: {
        display: 'flex',
        alignItems: 'center',
        height: CRED_ITEM_HEIGHT,
    },

    dragHandle: {
        cursor: 'row-resize',
        color: theme.palette.text.secondary,
    },

    credentialText: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    credentialCard: {
        display: 'flex',
        flexDirection: 'row',
    },

    credentialTextTitle: {
        fontWeight: 500,
        lineHeight: '16px',
    },

    credentialTextDesc: {
        fontWeight: 'normal',
        fontSize: 'smaller',
        lineHeight: '16px',
        color: theme.palette.text.secondary,
    },
    credentialDragPreview: {
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 1500,
        display: 'flex',
        alignItems: 'center',
        height: CRED_ITEM_HEIGHT,
        backgroundColor: theme.palette.action.selected,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[4],
        borderRadius: theme.shape.borderRadius,
        padding: '0 8px',
    },
    interfaceRuleMessage: {
        margin: '40px',
        fontSize: '20px',
    },
}));
